<template>
  <div id="page-container"></div>
</template>

<script>
import { useCommonStore } from "@/stores/CommonStore.ts";
import { mapActions } from "pinia";
import { isValidAccessionId } from "@/utils/accessionId.js";
export default {
  name: "CardioQnrPage",
  props: {
    accession_id: String,
    jwtToken: String,
    sample_id: String,
    role: String,
  },
  created() {
    this.setAccessionId(this.accession_id);
    this.setJwtToken(this.jwtToken);
    this.setSampleId(this.sample_id);
    this.setRole(this.role);
    // VP-18267: a link carrying accession_id=undefined must not become /cardioZoomer/undefined. Without
    // a usable accession the view sends the patient to verification with the accession input shown.
    this.$router.push(isValidAccessionId(this.accession_id) ? `/cardioZoomer/${this.accession_id}` : "/cardioZoomer");

  },
  methods: {
    ...mapActions(()=>useCommonStore(), ["setAccessionId","setSampleId", "setJwtToken", "setRole"]),
  },
};
</script>
